import React from 'react';

import OperatorSelect from './OperatorSelect';
import ReadOnlyOperator from './ReadOnlyOperator';

const Operator = ({ value, column, type, onChange, disabled, ...props }) => {
  if (value === 'IN') {
    return <ReadOnlyOperator showLabel={props.showLabel} value="In" />;
  }
  if (value === 'NOT IN') {
    return <ReadOnlyOperator showLabel={props.showLabel} value="Not In" />;
  }

  return (
    <OperatorSelect
      {...props}
      value={value}
      column={column}
      type={type}
      onChange={onChange}
      disabled={disabled}
    />
  );
};

export default Operator;
